import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setScope } from "../features/auth/authSlice";
import { loadRecord as loadEmployee } from "../features/employee/employeeSlice";
import { useIonToast } from "@ionic/react";
import { useSelector } from "react-redux";
import moment from "moment";
import "moment/locale/he";
import {
  IonTabs,
  IonTabBar,
  IonIcon,
  IonTabButton,
  IonLabel,
  IonRouterOutlet,
} from "@ionic/react";
import {
  helpBuoyOutline,
  walkOutline,
  settingsOutline,
  homeOutline,
} from "ionicons/icons";
import { Redirect, Route } from "react-router-dom";
import Home from "../features/home";
import Visits from "../features/visits";
import Patients from "../features/patients";
import Patient from "../features/patient";
import Visit from "../features/visit";
import NewVisit from "../features/visit/NewVisit";
import ControllerVisits from "../features/controllerVisits";
import Settings from "../features/settings";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

const HouseVisitsDashboard = (props) => {
  const { parentRef, match } = props;
  const { profile } = useSelector((state) => state.auth);
  let location = useLocation();
  const intl = useIntl();
  const [present] = useIonToast();
  const [selectedTab, setSelectedTab] = useState("home");
  const dispatch = useDispatch();
  useEffect(() => {
    moment.locale("he");
    const paths = ["home", "visits", "patients", "settings"];
    paths.forEach((item) => {
      const path = location.pathname && location.pathname.split("/")[2];
      if (path === item) {
        setSelectedTab(item);
      }
    });
  }, [dispatch, location.pathname]);
  useEffect(() => {
    if (profile.associated_employee_id) {
      const params = {
        id: profile.associated_employee_id,
      };
      dispatch(loadEmployee(params));
      dispatch(setScope(``));
    }
    if (profile && !profile.associated_employee_id) {
      present({
        color: "danger",
        duration: 2000,
        position: "top",
        message: intl.formatMessage({
          id: `app.mobile.notifications.not_associated`,
        }),
      });
    }
    if (profile && !profile.has_mobile_access) {
      present({
        color: "danger",
        duration: 2000,
        position: "top",
        message: intl.formatMessage({
          id: `app.mobile.notifications.no_mobile_access`,
        }),
      });
    }
  }, [profile, dispatch]);
  const routerRef = useRef();
  return (
    <IonTabs>
      <IonRouterOutlet ref={routerRef} swipeGesture={"false"} slot="top">
        <Route
          exact
          path={`/app`}
          render={() => <Redirect to={`/app/home`} />}
        />

        <Route
          path={`/app/:tab(home)`}
          exact={true}
          render={(props) => <Home {...props} />}
        />
        <Route
          path={`/app/:tab(visits)`}
          exact={true}
          render={(props) => <Visits {...props} />}
        />
        <Route
          path={`/app/:tab(settings)`}
          exact={true}
          render={(props) => (
            <Settings routerRef={parentRef.current} {...props} />
          )}
        />
        <Route
          exact
          path={`/app/visits/:branchId/:patientId/:id`}
          render={(props) => <Visit routerRef={parentRef.current} {...props} />}
        />
        <Route
          exact={true}
          path={`/app/:tab(patients)`}
          render={(props) => (
            <Patients routerRef={parentRef.current} {...props} />
          )}
        />
        <Route
          exact
          path={`/app/:tab(patients)/:branchId/:patientId`}
          render={(props) => (
            <Patient
              routerRef={parentRef.current}
              {...props}
              type={"fromPatient"}
            />
          )}
        />
        <Route
          exact
          path={`/app/:tab(patients)/:branchId/:patientId/newvisit`}
          render={(props) => (
            <NewVisit
              routerRef={parentRef.current}
              {...props}
              type={"fromPatient"}
            />
          )}
        />
        <Route
          exact
          path={`/app/controllervisits`}
          render={(props) => (
            <ControllerVisits routerRef={parentRef.current} {...props} />
          )}
        />
      </IonRouterOutlet>

      <IonTabBar slot="bottom">
        <IonTabButton
          tab="home"
          id="home"
          href={`/app/home`}
          selected={selectedTab === "home"}
        >
          <IonIcon icon={homeOutline} />
          <IonLabel>
            {intl.formatMessage({
              id: `app.mobile.tabs.home`,
            })}
          </IonLabel>
        </IonTabButton>
        <IonTabButton
          tab="visits"
          id="visits"
          href={`/app/visits`}
          selected={selectedTab === "visits"}
        >
          <IonIcon icon={walkOutline} />
          <IonLabel>
            {intl.formatMessage({
              id: `app.mobile.tabs.visits`,
            })}
          </IonLabel>
        </IonTabButton>
        <IonTabButton
          tab="patients"
          id="patients"
          href={`/app/patients`}
          selected={selectedTab === "patients"}
        >
          <IonIcon icon={helpBuoyOutline} />
          <IonLabel>
            {intl.formatMessage({
              id: `app.mobile.tabs.patients`,
            })}
          </IonLabel>
        </IonTabButton>
        <IonTabButton
          tab="settings"
          id="settings"
          href={`/app/settings`}
          selected={selectedTab === "settings"}
        >
          <IonIcon icon={settingsOutline} />
          <IonLabel>
            {intl.formatMessage({
              id: `app.mobile.tabs.settings`,
            })}
          </IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default HouseVisitsDashboard;

//
// <div id="outer-container">
//   <Menu
//     pageWrapId={"page-wrap"}
//     outerContainerId={"outer-container"}
//     right
//     customBurgerIcon={false}
//     customCrossIcon={false}
//     width={"50%"}
//   >
//     <HouseVisitsMenu routeDefinitions={routeDefinitions} />
//   </Menu>
//
//   <div id="page-wrap">
//     <HouseVisitsHeader />
//     <Router defaultResource={routeDefinitions[0].path} />
//   </div>
// </div>
